export default {
  Web: 'Web',
  NordLock: 'NordLock',
  Superbolt: 'Superbolt',
  Expander: 'Expander',
  Boltight: 'Boltigh'
}
